import { useRef } from "react";

export default function InputOTP({
  length = 6,
  value = "",
  onChange,
  autoFocus = true,
}) {
  const inputsRef = useRef([]);

  const handleInput = (e, index) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 1);
    const newOTP = value.split("");
    newOTP[index] = val;
    const otpValue = newOTP.join("");

    onChange(otpValue);

    if (val && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const containerStyle = {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
  };

  const inputStyle = {
    width: "40px",
    height: "50px",
    fontSize: "24px",
    textAlign: "center",
    border: "1px solid #ccc",
    borderRadius: "6px",
  };

  return (
    <div style={containerStyle}>
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          type="text"
          inputMode="numeric"
          style={inputStyle}
          maxLength="1"
          value={value[i] || ""}
          onChange={(e) => handleInput(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          ref={(el) => (inputsRef.current[i] = el)}
          autoFocus={autoFocus && i === 0}
        />
      ))}
    </div>
  );
}
